import React from 'react';
import { tUi } from '../../../../../../../../utils/dq_lc';
import {
  SlideDescription,
  PointText,
} from '../../../../../styles/LearnTab/slideBase.styles';
import { SlideTitleHeader } from '../common/SlideTitleHeader.comp';
import { renderTextWithId } from '../common/EditableSlideField.comp';

export const AnalysisFrameworkSlide = ({
  slide,
  highlightWord,
  slideEdits = {},
  showEnglishContent = false,
  uiLocale = 'en-US',
}) => {
  const fw = slide?.FrameworkData;
  const accent = '#3D5AFE';

  const textRendererOptions = { slideEdits, showEnglishContent, highlightWord };

  if (!fw) {
    return (
      <SlideDescription>
        <SlideTitleHeader
          slide={slide}
          slideEdits={slideEdits}
          showEnglishContent={showEnglishContent}
          highlightWord={highlightWord}
        />
        {renderTextWithId('content_0', slide?.SlideContent, PointText, {}, textRendererOptions)}
      </SlideDescription>
    );
  }

  return (
    <SlideDescription>
      <SlideTitleHeader
        slide={slide}
        slideEdits={slideEdits}
        showEnglishContent={showEnglishContent}
        highlightWord={highlightWord}
      />
      {fw.framework_name && (
        <PointText style={{ fontWeight: 600, marginBottom: 8 }}>
          {renderTextWithId('fw_name', fw.framework_name, 'span', {}, textRendererOptions)}
        </PointText>
      )}
      <ul>
        {(fw.principles || []).map((p, idx) => (
          <li key={idx}>
            <PointText>{renderTextWithId(`fw_p_${idx}`, p, 'span', {}, textRendererOptions)}</PointText>
          </li>
        ))}
      </ul>
      {fw.application_note && (
        <div style={{ background: `${accent}10`, padding: '10px 14px', borderRadius: 8, marginTop: 8 }}>
          <PointText>
            <strong>{tUi('slide.analysis.howToApply', uiLocale)}</strong> {renderTextWithId('fw_apply', fw.application_note, 'span', {}, textRendererOptions)}
          </PointText>
        </div>
      )}
    </SlideDescription>
  );
};

export default AnalysisFrameworkSlide;
